<template>
  <v-navigation-drawer
    v-if="!isEndCustomer && showDrawer"
    v-model="drawer"
    class="primary darken-1 overlay"
    :width="280"
    dark
    app
  >
    <v-list class="pt-0">

      <v-list-item two-line>
        <v-list-item-avatar>
          <img :src="require('@/assets/images/avatar-default.png')">
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="subheading">{{ displayName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        :to="item.route"
        dark
        active-class="primary"
        :class="{dimmed: item.isPro && !isSparkProUser}"
      >
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>
            {{ item.title }}
            <v-chip v-if="item.isPro" style="float: right;" small color="primary darken-3">
              {{ $t('sparkPro.pro') }}
            </v-chip>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="!isEndCustomer"
        key="signOut"
        dark
        @click="signOut"
      >
        <v-list-item-action>
          <v-icon>logout</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{$t('errands.logOut')}}</v-list-item-title>
        </v-list-item-content>

      </v-list-item>
    </v-list>
    <template v-slot:append v-if="isSparkProUser">
        <div class="mb-5 d-flex justify-center">
          <v-img
            max-width="130"
            :src="require('@/assets/images/Polygon_Spark_Pro_logo.png')"
          ></v-img>
        </div>
      </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      drawer: false
    }
  },
  mounted() {
    this.$parent.$on('toggle-drawer', () => {
      this.drawer = !this.drawer
    })
  },
  computed: {
    showDrawer() {
      return !this.get(this.$route, 'meta.hideLayout')
    },
    items() {
      return [
        {
          title: this.$t('errands.allErrands'),
          icon: 'format_list_bulleted',
          route: '/',
          isPro: false
        },
        {
          title: this.$t('calendar.heading'),
          icon: 'calendar_today',
          route: '/calendar',
          isPro: true
        },
        {
          title: this.$t('analytics.heading'),
          icon: 'show_chart',
          route: '/analytics',
          isPro: true
        },
        {
          title: 'FAQ',
          icon: 'mdi-message-question-outline',
          route: '/FAQ',
          isPro: false
        },
        {
          title: this.$t('sparkPro.heading'),
          icon: 'mdi-star',
          route: '/spark-pro',
          isPro: false
        }
      ]
    }
  },
  methods: {
    signOut() {
      this.$store.dispatch('logout')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.overlay {
  z-index: 100;
  min-height: 100%;
  background: linear-gradient(180deg, rgba(var(--color-primary),1) 60%, rgba(var(--color-subtle),1));
  // background: rgba(var(--color-primary),1);

}

.dimmed{
  opacity: 0.5;
}
</style>
